import CustomSwitch from 'components/CustomSwitch';
import React from 'react';

import routes from './routes';

function SitesRoutes() {
  return <CustomSwitch routes={routes} />;
}

export default SitesRoutes;
